// import data from './data/data.json';

// Geographic extent of the map (lon/lat). Matches the bbox used to clip the
// basemap and plate-boundary data in the scripts/ conversion steps.
export const EXTENT = {
  minLon: -108,
  minLat: -8,
  maxLon: -57,
  maxLat: 26,
};

// On mobile the frame is portrait, so we show a taller slice (more of South
// America to the south and Mexico/Gulf to the north) rather than the same
// wide extent letterboxed in sea. Same longitude -> no horizontal cropping.
export const MOBILE_EXTENT = {
  minLon: -108,
  minLat: -20,
  maxLon: -57,
  maxLat: 32,
};

// Palette (tuned to the example graphic).
export const COLORS = {
  sea: '#f1f8fe',
  land: '#ffffff',
  landColombia: '#f7f9fa',
  coastShadow: '#8fb0c6',
  countryLine: '#b9c4cb',
  disputed: '#b6b2a8',
  plate: '#2d7d78',
  quake: '#c52622',
  countryLabel: '#8b98a0',
  seaLabel: '#7fa9bd',
  annotation: '#262626',
  leader: '#8b98a0',
};

// Only earthquakes at or above this magnitude are shown.
export const MIN_MAGNITUDE = 7;

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    height,
    initialWidth,
    initialHeight,
    isMobile,
    margins,
    width,
  };
}
